export default "__VITE_ASSET__ddo_s2t___"